import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { IconCross } from 'components/Icons';
import styles from 'components/Faqs/FaqItem/FaqItem.module.scss';

const cn = classNames.bind(styles);

interface FaqItem {
  id: string;
  question: string;
  answer: (cn: Function) => string;
  customClassNames?: {
    container?: string;
    label?: string;
    heading?: string;
    iconContainer?: string;
    answerContainer?: string;
    answerParagraph?: string;
  }
};

const FaqItem: FC<FaqItem> = ({ id, question, answer, customClassNames }): ReactElement => {
  return (
    <li
      className={cn('faq', customClassNames?.container)}
      key={id}
    >
      <input type='checkbox' name={id} id={id} />
      <label htmlFor={id} className={cn('faq__label', customClassNames?.label)}>
        <h3 className={cn('faq__heading', customClassNames?.heading)}>{question}</h3>
        <div className={cn('faq__icon-container', customClassNames?.iconContainer)}>{IconCross}</div>
      </label>
      <div className={cn('faq__answer', customClassNames?.answerContainer)}>
        <div className={cn('faq__answer-content')} dangerouslySetInnerHTML={{ __html: answer(cn)}} />
      </div>
    </li>
  );
};

export { FaqItem };